import clsx from 'clsx'
import {useRef, useState} from 'react'
import {KTIcon} from '../../../helpers'
import {HeaderNotificationsMenu} from '../../../partials'
import {useLayout} from '../../core'
import {useAuth} from '../../../../app/modules/auth'
import Clock from './Clock'
import {useNotifications} from '../../../../app/hooks/useNotifications'

const itemClass = 'ms-1 ms-md-4'
const btnClass =
  'btn btn-icon btn-custom btn-icon-muted btn-active-light btn-active-color-primary w-35px h-35px'
const userAvatarClass = 'symbol-35px'
const btnIconClass = 'fs-2'

const Navbar = () => {
  const {currentUser} = useAuth()
  const {notifications, unreadCount, markAllAsReadApi, markAsReadApi, fetchUnreadCount} =
    useNotifications(true)
  const [isMenuHovered, setIsMenuHovered] = useState(false)
  const lastHoverFetchRef = useRef<number>(0)

  return (
    <div className='app-navbar flex-shrink-0'>
      {/* Notifications */}
      {/* <div 
        className={clsx('app-navbar-item position-relative', itemClass)}
        onMouseEnter={() => {
          setIsMenuHovered(true)
          const now = Date.now()
          if (now - lastHoverFetchRef.current > 25000) {
            lastHoverFetchRef.current = now
            void fetchUnreadCount()
          }
        }}
        onMouseLeave={() => setIsMenuHovered(false)}
      >
        <div className={clsx('position-relative', btnClass)}>
          <KTIcon iconName='notification-on' className={btnIconClass} />
          {unreadCount > 0 && (
            <span 
              className='badge badge-circle badge-danger position-absolute translate-middle top-0 start-100'
              style={{
                width: '18px',
                height: '18px',
                fontSize: '11px',
                fontWeight: 700,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '0',
                background: '#ef4444',
                color: '#ffffff'
              }}
            >
              {unreadCount > 99 ? '99+' : unreadCount}
            </span>
          )}
        </div>
        
        <div className={clsx('menu-sub menu-sub-dropdown w-350px w-lg-375px', {show: isMenuHovered})} style={{
          position: 'absolute',
          top: '100%',
          right: 0,
          zIndex: 105,
          opacity: isMenuHovered ? 1 : 0,
          visibility: isMenuHovered ? 'visible' : 'hidden',
          transition: 'all 0.3s ease'
        }}>
          <HeaderNotificationsMenu 
            notifications={notifications} 
            unreadCount={unreadCount} 
            markAllAsReadApi={markAllAsReadApi} 
            markAsReadApi={markAsReadApi}
          />
        </div>
      </div> */}

      {/* Theme mode switcher removed as per user request */}


      <div className='d-flex gap-4 ms-4'>
        <Clock />
      </div>

      <div className={clsx('app-navbar-item', itemClass)}>
        <div
          className={clsx('cursor-pointer symbol', userAvatarClass)}
          data-kt-menu-trigger="{default: 'click'}"
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
        >
          {currentUser?.profile_photo_url ? (
            <img
              src={currentUser.profile_photo_url}
              alt='profile'
              style={{
                height: '35px',
                width: '35px',
                borderRadius: '8px',
                objectFit: 'cover',
              }}
            />
          ) : (
            <div
              className='d-flex align-items-center justify-content-center symbol'
              style={{
                height: '35px',
                width: '35px',
                borderRadius: '8px',
                backgroundColor: '#E8912D',
                color: '#fff',
                fontWeight: 'bold',
                fontSize: '12px',
              }}
            >
              {typeof currentUser?.user_type === 'string' && currentUser.user_type.trim().length > 0
                ? currentUser.user_type.trim().substring(0, 2).toUpperCase()
                : typeof currentUser?.name === 'string' && currentUser.name.trim().length > 0
                ? currentUser.name.trim().substring(0, 2).toUpperCase()
                : 'NA'}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export {Navbar}
